import React, { useState } from 'react';
import './SearchBarIntervenat.css';
import { useTranslation } from 'react-i18next';

function SearchBarIntervenant(props) {
  const [searchInput, setSearchInput] = useState(''); // pas null
  const { t } = useTranslation();

  const handleSearch = () => {
    if (!searchInput) {
      // si vide, retourne tout
      props.onFilter(props.userData);
      return;
    }

    const filteredUsers = props.userData.filter((user) =>
      user.nom_user.toLowerCase().includes(searchInput.toLowerCase())
    );
    props.onFilter(filteredUsers);
  };

  return (
    <div className="search-bar">
      <input
        type="text"
        placeholder={t("searchBar.placeholder")}
        value={searchInput}
        onChange={e => setSearchInput(e.target.value)}
      />
      <button onClick={handleSearch}>
        {t("searchBar.button")}
      </button>
    </div>
  );
}

export default SearchBarIntervenant;